
<div  style="height: 344px;width:100%;z-index:0" id="map" ></div>